module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-left"
  }, [(_vm.operation.payment_number) ? _c('span', [_vm._v(_vm._s('№ операции: ' + _vm.operation.payment_number))]) : _c('span', [_vm._v("Новая операция")])]), _vm._v(" "), _c('template', {
    slot: "header-center"
  }), _vm._v(" "), _c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('z-input', {
    staticClass: "col-6",
    attrs: {
      "disabled": _vm.progress,
      "name": "payment_number",
      "id": "payment_number",
      "label": "Номер операции (crm)",
      "error": _vm.errors.first('payment_number')
    },
    model: {
      value: (_vm.operation.payment_number),
      callback: function($$v) {
        _vm.$set(_vm.operation, "payment_number", $$v)
      },
      expression: "operation.payment_number"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "col-6",
    attrs: {
      "disabled": "",
      "readonly": "",
      "name": "ones_id",
      "id": "ones_id",
      "label": "Номер операции (1С)",
      "error": _vm.errors.first('ones_id')
    },
    model: {
      value: (_vm.operation.ones_id),
      callback: function($$v) {
        _vm.$set(_vm.operation, "ones_id", $$v)
      },
      expression: "operation.ones_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "id": "operation_type",
      "name": "operation_type",
      "label": "Тип операции",
      "disabled": _vm.progress,
      "required": true,
      "error": _vm.errors.first('operation_type')
    },
    model: {
      value: (_vm.operation.type),
      callback: function($$v) {
        _vm.$set(_vm.operation, "type", $$v)
      },
      expression: "operation.type"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Приход")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Расход")])]), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "payment-method col-6",
    attrs: {
      "id": "payment_method_id",
      "name": "payment_method_id",
      "label": "Способ оплаты",
      "required": true,
      "data-vv-name": "payment_method_id",
      "data-vv-as": ' ',
      "error": _vm.errors.first('payment_method_id'),
      "disabled": _vm.isCreated && !!parseInt(_vm.operation.payment_method_id)
    },
    model: {
      value: (_vm.operation.payment_method_id),
      callback: function($$v) {
        _vm.$set(_vm.operation, "payment_method_id", $$v)
      },
      expression: "operation.payment_method_id"
    }
  }, _vm._l((_vm.paymentMethods), function(item) {
    return _c('option', {
      key: ('payment-method-' + item.id),
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "id": "company_id",
      "name": "company_id",
      "label": "Получатель",
      "disabled": _vm.progress,
      "required": true,
      "data-vv-as": ' ',
      "error": _vm.errors.first('company_id')
    },
    model: {
      value: (_vm.operation.company_id),
      callback: function($$v) {
        _vm.$set(_vm.operation, "company_id", $$v)
      },
      expression: "operation.company_id"
    }
  }, _vm._l((_vm.companies), function(company) {
    return _c('option', {
      key: ('company-' + company.id),
      domProps: {
        "value": company.id
      }
    }, [_vm._v(_vm._s(company.name))])
  })), _vm._v(" "), _c('z-input-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "id": "customer_id",
      "name": "customer_id",
      "label": "Плательщик",
      "disabled": _vm.progress,
      "update-on-input": true,
      "callback": _vm.searchCustomerByName,
      "length-on-search": 5,
      "property": "id",
      "display-property": "name",
      "display-property-list": "name",
      "default": _vm.operation.customer.name,
      "required": "",
      "error": _vm.errors.first('customer_id'),
      "data-vv-name": "customer_id",
      "data-vv-as": ' '
    },
    on: {
      "clear": _vm.clearCustomer
    },
    model: {
      value: (_vm.operation.customer_id),
      callback: function($$v) {
        _vm.$set(_vm.operation, "customer_id", $$v)
      },
      expression: "operation.customer_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-date', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true
      }),
      expression: "{'required': true}"
    }],
    staticClass: "col-4",
    attrs: {
      "label": "Дата платежа",
      "placeholder": "Дата платежа",
      "format": "DD.MM.YYYY HH:mm",
      "type": "datetime",
      "disabled": _vm.progress,
      "required": "",
      "no-margin": "",
      "data-vv-name": "date",
      "data-vv-as": ' ',
      "error": _vm.errors.first('date')
    },
    model: {
      value: (_vm.operation.date),
      callback: function($$v) {
        _vm.$set(_vm.operation, "date", $$v)
      },
      expression: "operation.date"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "col-4",
    attrs: {
      "disabled": "",
      "readonly": "",
      "name": "created_at",
      "id": "created_at",
      "label": "Дата создания",
      "error": _vm.errors.first('created_at')
    },
    model: {
      value: (_vm.operation.created_at),
      callback: function($$v) {
        _vm.$set(_vm.operation, "created_at", $$v)
      },
      expression: "operation.created_at"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "col-4",
    attrs: {
      "disabled": "",
      "readonly": "",
      "name": "updated_at",
      "id": "updated_at",
      "label": "Дата обновления",
      "error": _vm.errors.first('updated_at')
    },
    model: {
      value: (_vm.operation.updated_at),
      callback: function($$v) {
        _vm.$set(_vm.operation, "updated_at", $$v)
      },
      expression: "operation.updated_at"
    }
  })], 1), _vm._v(" "), (_vm.operation && _vm.operation.deal && _vm.operation.deal.first_freight && _vm.operation.deal.first_freight.traking_number) ? _c('z-input', {
    attrs: {
      "disabled": "",
      "readonly": "",
      "name": "traking_number",
      "id": "traking_number",
      "label": "Заявка",
      "error": _vm.errors.first('traking_number')
    },
    model: {
      value: (_vm.operation.deal.first_freight.traking_number),
      callback: function($$v) {
        _vm.$set(_vm.operation.deal.first_freight, "traking_number", $$v)
      },
      expression: "operation.deal.first_freight.traking_number"
    }
  }) : _vm._e(), _vm._v(" "), _c('z-input', {
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "type": "number",
      "name": "sum",
      "id": "sum",
      "label": "Сумма (руб.)",
      "error": _vm.errors.first('sum')
    },
    model: {
      value: (_vm.operation.sum),
      callback: function($$v) {
        _vm.$set(_vm.operation, "sum", $$v)
      },
      expression: "operation.sum"
    }
  }), _vm._v(" "), _c('z-text-area', {
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "name": "description",
      "id": "description",
      "label": "Описание",
      "error": _vm.errors.first('description')
    },
    model: {
      value: (_vm.operation.description),
      callback: function($$v) {
        _vm.$set(_vm.operation, "description", $$v)
      },
      expression: "operation.description"
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de8c901c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/finance/views/Operation.vue
// module id = 1265
// module chunks = 0